import React from 'react';

import {
  Dropdown,
  Breadcrumb,
  Box,
  StyledOcticon,
  Heading,
  TabNav,
  CounterLabel,
  Text,
} from '@primer/components'
import { IssueOpened, Gear, GitPullRequest } from '@primer/octicons-react'

import { Link } from "react-router-dom";


const styleChangeBranch = {
  paddingLeft: 0,
  paddingRight: 0,
  fontSize: '20px',
  background: 'transparent',
  color: 'white',
  boxShadow: 'none'
}

const styleSwitchBranchLabel = {
  color: '#24292e',
  fontSize: '14px',
  padding: '4px 15px 10px 15px',
  borderBottom: '1px solid #dedede',
  fontWeight: 'bold',
}

export const TAB_ISSUES = 'issues'
export const TAB_FIX = 'fix'
export const TAB_SETTINGS = 'settings'

export default function RepositoryHeader(props) {
  return (
    <Box style={{'backgroundColor': 'rgb(27, 31, 35)'}}>
      <Box className="container-lg p-2">
        <Breadcrumb className=" mt-4 ml-3 mb-3 ml-md-0 mt-md-0 mb-md-4 ">
          <Breadcrumb.Item>
            <Link to={`/${props.owner}`}>
              <Heading fontSize={3}>{props.owner}</Heading>
            </Link>
          </Breadcrumb.Item>
          <Breadcrumb.Item selected>
            <Heading fontSize={3} color={'white'}>{props.repository}</Heading>
          </Breadcrumb.Item>

          <Breadcrumb.Item verticalAlign='middle'>
            <Dropdown overlay={true} style={{ lineHeight: 1.5, fontSize: '20px',}}>
              <Dropdown.Button
                style={styleChangeBranch}
                onClick={props.onBranchMenuToggle}
              >
                {props.branch}
              </Dropdown.Button>
              <Dropdown.Menu direction='sw'>
                <p style={styleSwitchBranchLabel}>Switch to branch</p>
                {
                  props.branches.map(({ name }) => (
                    <Dropdown.Item
                      key={name}
                      onClick={() => props.onBranchChange(name)}
                      style={{cursor: 'pointer', fontSize: '14px'}}
                      title={name}
                    >
                      { name }
                    </Dropdown.Item>
                  ))
                }
              </Dropdown.Menu>
            </Dropdown>
          </Breadcrumb.Item>
        </Breadcrumb>
      </Box>
      <TabNav className={"container-lg"} style={{borderBottom: 0}}>
        <TabNav.Link
          selected={props.activeTab === TAB_ISSUES}
          onClick={() => props.handleChangeTab(TAB_ISSUES)}
          style={{cursor: 'pointer'}}
        >
          <StyledOcticon
            color={props.activeTab === TAB_ISSUES ? 'black' : 'white'}
            icon={IssueOpened}
            size={16}
            marginRight={'6px'}
          />
          <Text color={props.activeTab === TAB_ISSUES ? 'black' : 'white'}>Audit</Text>
          <CounterLabel>{props.adviceCount}</CounterLabel>
        </TabNav.Link>
        <TabNav.Link
          selected={props.activeTab === TAB_SETTINGS}
          onClick={() => props.handleChangeTab(TAB_SETTINGS)}
          style={{cursor: 'pointer'}}
        >
          <StyledOcticon
            color={props.activeTab === TAB_SETTINGS ? 'black' : 'white'}
            icon={Gear}
            size={16}
            marginRight={'6px'}
          />
          <Text color={props.activeTab === TAB_SETTINGS ? 'black' : 'white'}>Settings</Text>
        </TabNav.Link>
      </TabNav>
    </Box>
  
  )
}
